import { useDesign } from '../context/DesignContext';
import WeeklyViewA from './WeeklyViewA';
import WeeklyViewB from './WeeklyViewB';
import WeeklyViewC from './WeeklyViewC';

const views = { A: WeeklyViewA, B: WeeklyViewB, C: WeeklyViewC };

export default function WeekPage() {
  const { design } = useDesign();
  const View = views[design];
  return <View />;
}
